import { render, staticRenderFns } from "./BgqwPage16.vue?vue&type=template&id=d591ac82"
import script from "./BgqwPage16.vue?vue&type=script&lang=js"
export * from "./BgqwPage16.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports